import React from "react";
import styles from "../styles/campaignNotifications.module.scss";

export default function CampaignSendCounts({ sendCounts = {} }) {
  const sent = Number(sendCounts.sent) || 0;
  const skipped = Number(sendCounts.skipped) || 0;
  const failed = Number(sendCounts.failed) || 0;

  return (
    <div className={styles.counts}>
      <span className={`${styles.badge} ${styles.badgeSent}`}>Sent {sent}</span>
      <span className={`${styles.badge} ${styles.badgeSkipped}`}>
        Skipped {skipped}
      </span>
      <span className={`${styles.badge} ${styles.badgeFailed}`}>
        Failed {failed}
      </span>
    </div>
  );
}
